<template>
    <v-card v-if="survey && plant">
        <v-lazy>
        <ImageCard :refId="survey" type="survey"></ImageCard>
        </v-lazy>
        <v-badge :content="parentCount" color="green" offset-y="30" v-if="parentCount > 0">
          <v-card-title>{{survey.customer}}</v-card-title>
        </v-badge>
        <v-card-title v-else>{{survey.customer}}</v-card-title>

        <v-card-subtitle>{{plant.name}}</v-card-subtitle>
        <v-card-text>{{survey.action | actionText | capitalize}} {{survey.date}} ({{survey.timeStart}} - {{survey.timeEnd}})</v-card-text>
        <v-card-actions>
            <v-btn text icon color="green" :to="{name: 'SurveyAdd', params:{parentId: survey.uuid}}">
                <v-icon>mdi-note-plus</v-icon>
            </v-btn>
                <v-btn text icon :color="assignWorker?'orange':'green'" @click="$emit('showDialog',survey.uuid)" v-if="authorized">
                    <v-icon>mdi-clipboard-account</v-icon>
                </v-btn>
            <v-spacer></v-spacer>
            <v-btn text icon color="green" :to="{name: 'Survey', params: {surveyId: survey.uuid}}" v-if="authorized">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn text icon color="red" @click="onDelete(survey.uuid)" v-if="authorized">
                <v-icon>mdi-delete</v-icon>
            </v-btn>
            <ConfirmDialog ref="confirm"></ConfirmDialog>
        </v-card-actions>
    </v-card>
</template>

<script>
    import {Actions, Roles} from '../../_helpers';
    import ImageCard from '../../base/ImageCard'
    import ConfirmDialog from '../../base/ConfirmDialog';

    export default {
        name: 'SurveyCard',
        props: ['survey'],
        components: {
            ConfirmDialog,
            ImageCard
        },
        data:()=> (
            {
            showUsers: false
            }
        ),
        computed: {
            plant() {
                return this.$store.state.plant.plantList.find(plant => plant.uuid === this.survey.neophyte)
            },
            imageId() {
                return (this.survey.imageIds && this.survey.imageIds.length > 0) ? this.survey.imageIds[0] : null
            },
            parentCount() {
                let counter = 0

                if (this.survey.parentid) {
                  counter = this.countParents(this.survey.parentid);
                }

                return counter;
            },
            authorized() {
                let userProfile = this.$store.getters.userProfile

                // Check authentication of user
                if (!this.$store.getters.isAuthenticated || !userProfile)
                    return false

                if (userProfile.role === Roles.ROLE_1.value) {
                    return true // SUPERADMIN is always allowed to manage it
                }
                else if (userProfile.role === Roles.ROLE_2.value) {
                    // get all users
                    let userList = this.$store.getters.userList

                    // map contractor to user-object
                    let contractorUser = userList.find(user => user.email === this.survey.contractor)

                    if (contractorUser) {
                        // filter users which belong to same province as contractor
                        let provinceUsers = userList.filter(user => user.province === contractorUser.province)

                        // does signed-in user belong to province?
                        return provinceUsers.some(item => item.email === userProfile.email)
                    } else {
                        return false
                    }
                }
                else if (userProfile.role === Roles.ROLE_3.value) {
                    return this.survey.contractor === userProfile.email
                }
                else {
                    return false
                }
            },
            assignWorker() {
                if(typeof this.survey.assignedWorker == 'undefined' || this.survey.assignedWorker == null)
                    return false
                return (this.survey.assignedWorker.search('@')!=-1)
            }
        },
        filters: {
            actionText(enumValue) {
                let action = Actions.itemByValue(enumValue)
                return action ? action.text : ""
            },
            capitalize(value) {
                if (!value)
                    return ''

                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        methods: {
            onDelete(surveyId) {
                // Open confirmation dialog
                this.$refs.confirm.open(
                    this.$t('key.deleteSurveyTitle'),
                    this.$t('key.deleteSurveyText', {'0': this.survey.customer}), { color: 'red' })
                    .then((confirm) => {
                        if (confirm) {
                            this.$store.dispatch('deleteSurvey', surveyId)
                        }
                    })
            },
            countParents(surveyId, counter=1) {
              let surveyRef = this.$store.getters.surveyList.find(s => s.uuid == surveyId);

              // does surveyRef has another parent reference?
              if (surveyRef && surveyRef.parentid) {
                  console.log(surveyRef.parentid)
                  this.countParents(surveyRef.parentid, counter++)
              }

              return counter
            }
        }
    }
</script>

<style>

</style>
